module.exports = __webpack_public_path__ + "static/img/mask_small.2f73931.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/atmosphere-mask/images/mask_small.jpg
// module id = 81SF
// module chunks = 0